/**
 * The collab client's WebSocket URL: the injected value, else this page's own
 * `ws.` sibling.
 *
 * Call it with the env read written out at the call site —
 * `collabWsUrl(process.env.NEXT_PUBLIC_WS_URL)` — because Next only inlines a
 * static `process.env.NEXT_PUBLIC_X` member access, never one made in here.
 *
 * ## Why not `|| "wss://ws.<app>.l.gaz.codes"`
 *
 * That was the idiom in every collab app, and `NEXT_PUBLIC_*` is inlined at
 * BUILD time. Nothing injected the var, so every deployed bundle compiled in the
 * local literal and prod browsers synced against LOCAL's collab servers —
 * local's databases, local's auth (2026-10-14). `@workspace/stage-config` now
 * injects it on every stage. This fallback is for a build that missed the
 * injection anyway, and it must not be a hostname: any fixed host is right on
 * one stage and silently wrong on the others.
 *
 * Every collab server is routed at `ws.` + its page's host (`docs.gaz.codes` →
 * `ws.docs.gaz.codes`, `messaging.l.gaz.codes` → `ws.messaging.l.gaz.codes`),
 * so the page's own location gives the stage-correct answer.
 *
 * Returns `""` where there is no `window` (SSR). Providers open their socket in
 * an effect, so the server render never needs the URL.
 */
export function collabWsUrl(configured: string | undefined): string {
  if (configured) return configured
  if (typeof window === "undefined") return ""
  const { protocol, host } = window.location
  return `${protocol === "https:" ? "wss" : "ws"}://ws.${host}`
}
